// extracted by mini-css-extract-plugin
export default {"companyContainer":"dM-z","companyImage":"eM-z","container":"fM-z","heading":"gM-z","darkText":"hM-z","smallHeading":"iM-z","darkBackground":"jM-z","whiteBackground":"kM-z"};